export default [
  {
    url: '/safety',
    name: '안전실적',
    slug: 'safety',
    icon: 'PocketIcon',
    submenu: [
      {
        url: '/safety/regular-assessment',
        name: '정기 위험성평가',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/regular-assessment-always',
        name: '수시 위험성평가',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/daily-checklist',
        name: '일일안전점검표',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/daily-checklist-always',
        name: '수시일일안전점검표',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/daily-checklog',
        name: '안전점검일지',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/daily-checklog-always',
        name: '수시안전점검일지',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/equipment-checklist',
        name: '장비점검계획',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/equipment-checkresult',
        name: '장비점검 결과',
        slug: 'safety-director',
        icon: 'FileIcon'
      },
      {
        url: '/safety/daily-checklogall',
        name: '합동점검일지',
        slug: 'safety-director',
        icon: 'FileIcon'
      }
    ]
  },
  {
    url: '/state',
    name: '환경실적',
    slug: 'state',
    icon: 'LayoutIcon',
    submenu: [
      {
        url: '/state/daily-checklist',
        name: '환경일일점검',
        slug: 'state-director',
        icon: 'FileIcon'
      },
      {
        url: '/state/monthly-checklist',
        name: '환경월간점검',
        slug: 'state-director',
        icon: 'FileIcon'
      }
      // {
      //   url: '/state/monitoring-checklist',
      //   name: '환경점검모니터링',
      //   slug: 'state-director',
      //   icon: 'FileIcon'
      // }
    ]
  },
  {
    url: '/hse/health',
    name: '보건실적',
    slug: 'report',
    icon: 'ArchiveIcon',
    submenu: [
      {
        url: '/hse/health-list',
        name: '안전보건 주요일정',
        slug: 'state-director',
        icon: 'FileIcon'
      }
    ]
  },
  // {
  //   url: '/approval',
  //   name: '결재함',
  //   slug: 'report',
  //   icon: 'FileTextIcon',
  //   submenu: [
  //     {
  //       url: '/approval/request',
  //       name: '결재요청함',
  //       slug: 'state-director',
  //       icon: 'FileIcon'
  //     },
  //     {
  //       url: '/approval/await',
  //       name: '결재대기함',
  //       slug: 'state-director',
  //       icon: 'FileIcon'
  //     },
  //     {
  //       url: '/approval/process',
  //       name: '결재진행함',
  //       slug: 'state-director',
  //       icon: 'FileIcon'
  //     },
  //     {
  //       url: '/approval/complete',
  //       name: '완료문서함',
  //       slug: 'state-director',
  //       icon: 'FileIcon'
  //     },
  //     {
  //       url: '/approval/reject',
  //       name: '반려문서함',
  //       slug: 'state-director',
  //       icon: 'FileIcon'
  //     },
  //     {
  //       url: '/approval/reference',
  //       name: '참조/회람 문서함',
  //       slug: 'state-director',
  //       icon: 'FileIcon'
  //     }
  //   ]
  // },
  {
    url: '/prevention',
    name: '시정 및 예방요청서',
    slug: 'prevention',
    icon: 'CheckSquareIcon',
    submenu: [
      {
        url: '/prevention/safety-request',
        name: '안전이슈',
        slug: 'prevention-request',
        icon: 'FileIcon'
      },
      {
        url: '/prevention/environment-request',
        name: '환경이슈',
        slug: 'prevention-request',
        icon: 'FileIcon'
      },
      {
        url: '/prevention/health-request',
        name: '보건이슈',
        slug: 'prevention-request',
        icon: 'FileIcon'
      }
    ]
  }
]
